import React, { Component, Fragment } from 'react'
import { compose } from 'recompose'
import withData from '../../../../elements/Select/withData'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import { Button, Col, Divider, Form, Row } from 'antd'
import CustomTable from '../../../../elements/Table/CustomTable'

class GroupList extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const { next, groups, group, onChangeGroup } = this.props

    const GroupsNames = compose(
      withData({
        data: groups.map(g => ({
          key: g._id,
          value: g.name,
        })),
      }),
    )(CustomSelect)

    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }

    let selectedMembers = groups.filter(g => g._id === group)[0]
    selectedMembers = selectedMembers ? selectedMembers.members : []
    const { getFieldDecorator } = this.props.form

    return (
      <Fragment>
        <div className="steps-content">
          <Row>
            <Col span={12}>
              <Form.Item label="Group Name" {...formItemLayoutRow}>
                {getFieldDecorator('group.project._id', {})(
                  <GroupsNames onChange={onChangeGroup}/>,
                )}
                <Button
                  type="primary"
                  onClick={() => next({ isLast: true })}
                  disabled={!group || (selectedMembers.length === 0 && true)}>
                  Use This Group
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left">Select From Existing Member</Divider>
          <Row>
            <CustomTable
              data={selectedMembers}
              hide={{ create: true, refresh: true }}
              isFilterable={true}
              show={{ extraColumns: true }}
              columns={[
                {
                  Header: 'Name',
                  accessor: 'fn',
                },
                {
                  Header: 'Role',
                  accessor: 'role',
                },
                {
                  Header: 'Type',
                  accessor: 'type',
                },
              ]}
            />
          </Row>
        </div>
      </Fragment>
    )
  }
}

export default Form.create()(GroupList)
